<template>
  <ManageBox class="vehTypeManage">
    <template slot="upside">
      <el-form
        ref="form"
        :model="form"
        inline
        label-width="80px"
      >
        <el-form-item label="用户名">
          <el-input v-model.trim="form.userName" placeholder="请输入用户名" />
        </el-form-item>
      </el-form>
      <el-button
        size="small"
        type="primary"
        @click="getData"
      >查询</el-button>
    </template>

    <div
      class="vehTypeManage__content"
      slot="content"
    >
      <!-- 表格开始 -->
      <!-- :data="tableData.slice((currentPage-1)*pageSize,currentPage*pageSize)" -->
      <el-table
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 1)"
        height="100%"
        max-height="100%"
        :data="tableData"
        border
        stripe
        style="min-width: 100%"
        row-key="index"
        size="mini"
        ref="table">
        <el-table-column
          fixed
          prop="index"
          label="序号"
          width="50"
          align="center"
        />
        <el-table-column
          prop="userName"
          label="司机账号"
          minWidth="120"
          align="center"
        />
        <el-table-column
          prop="password"
          label="密码"
          minWidth="130"
          align="center"
        />
        <el-table-column
          property="createTime"
          label="创建时间"
          minWidth="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="operate"
          label="操作"
          width="120"
          align="center"
          v-slot="{ row }"
        >
          <el-tag @click="onDetail(row.userId)" type="success" class="cursor">绑定信息</el-tag>
        </el-table-column>
      </el-table>
      <!-- 表格结束 -->

      <!-- 分页开始 -->
      <el-pagination
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :page-sizes="[20, 50, 100]"
        @size-change="getData"
        @current-change="currentChange"
        layout="total,sizes, prev, pager, next, jumper"
        :total="total"
      />
      <!-- 分页结束 -->
       <DetailsInfo
        :visible.sync="visible"
        :userId="userId"
       />
    </div>
  </ManageBox>
</template>

<script>
import ManageBox from "@/components/ManageBox/index.vue";
import DetailsInfo from "./components/DetailsInfo.vue";
import { mapState } from 'vuex';
export default {
  components: {
    ManageBox,
    DetailsInfo
  },
  data() {
    return {
      form:{
        userName:'',
      },
      loading: false,
      visible:false,
      currentPage: 1,
      userId:null,
      pageSize: 100,
      tableData: [],
      getParams: {},
      total: 0,
    };
  },
  computed:{
      ...mapState(['USER']),
  },
  mounted() {
    //监听表格滚动
    const dom = this.$refs.table.bodyWrapper;
    dom.addEventListener("scroll", () => {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    });
  },

  methods: {
    // 绑定详情
    onDetail(userId){
      this.userId = userId;
      this.visible = true;
    },

    currentChange (val) {
      this.currentPage = val;
      this.getData();
    },
    //获取数据
    async getData() {
      let params = {
        pageSize:this.pageSize,
        pageNumber:this.currentPage,
        userName:this.form.userName
      };
      this.getParams = params;
      try {
        this.loading = true;
        const { data, total, code, msg } = await this.$API.pageBindDriverInfo(params);
        if(code !== 0) throw { msg };
        this.total = total;
        this.tableData = data?.map((item, index) => ({
          ...item,
          index: (this.currentPage - 1) * this.pageSize + index + 1
        })) ?? [];
        if (total === 0) {
          this.$msg({
            showClose: true,
            message: "暂无数据",
            type: "success"
          });
        }
      } catch (error) {
        this.$msg({
          showClose: true,
          message: error.msg,
          type: "error"
        });
      } finally{
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.vehTypeManage {
  &__content {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: #fff;
    padding: 16px;
  }
  &__footer {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: #fff;
    padding: 16px;
  }
}
span {
  color: rgb(179, 179, 179);
  margin: 10px;
}
::v-deep .el-form-item {
  margin-bottom: 2px;
}
.date{
  ::v-deep .el-form-item__content {
    margin-left: 0 !important;
    width: 420px;
  }
}
::v-deep .el-col-1 {
  margin-left: 2%;
}
.cursor{
  cursor: pointer;
}
</style>
